import React, { useState, useEffect } from 'react';
import { useReturnContext } from '../context/ReturnContext';
import './ReturnTypeSelection.css';

export default function ReturnTypeSelection({ onTypeSelected, onBack }) {
  const { returnType: contextReturnType, setReturnType: setContextReturnType } = useReturnContext();
  const [localReturnType, setLocalReturnType] = useState(contextReturnType || 'return');
  
  // Update local state when context changes
  useEffect(() => {
    if (contextReturnType) {
      setLocalReturnType(contextReturnType);
    }
  }, [contextReturnType]);
  
  // Update context when local state changes
  useEffect(() => {
    setContextReturnType(localReturnType);
  }, [localReturnType, setContextReturnType]);

  const handleContinue = () => {
    onTypeSelected(localReturnType);
  };

  return (
    <div className="return-type-selection">
      <h2 className="section-title">Select Return Type</h2>
      <p className="mb-6 text-gray-600">
        Please select whether you want to return the items for a refund or exchange them for other items.
      </p>
      
      <div className="mb-6">
        <div className="return-type-options">
          <div 
            className={`return-type-option ${localReturnType === 'return' ? 'selected' : ''}`}
            onClick={() => setLocalReturnType('return')}
          >
            <div className="icon">
              <i className="fas fa-undo-alt"></i>
            </div>
            <div className="content">
              <h3>Return for Refund</h3>
              <p>Return your items for a refund to your original payment method.</p>
            </div>
          </div>
          
          <div 
            className={`return-type-option ${localReturnType === 'exchange' ? 'selected' : ''}`}
            onClick={() => setLocalReturnType('exchange')}
          >
            <div className="icon">
              <i className="fas fa-exchange-alt"></i>
            </div>
            <div className="content">
              <h3>Exchange for Other Items</h3>
              <p>Exchange your items for other products from our store.</p>
            </div>
          </div>
        </div>
      </div>
      
      <div className="d-flex justify-content-between">
        <button 
          type="button" 
          className="btn btn-secondary"
          onClick={onBack}
        >
          <i className="fas fa-arrow-left mr-2"></i> Back
        </button>
        <button 
          type="button" 
          className="btn btn-primary"
          onClick={handleContinue}
        >
          Continue <i className="fas fa-arrow-right ml-2"></i>
        </button>
      </div>
    </div>
  );
}
